import React from "react";
import { Skeleton } from "@mui/material";

export const PriorityTasksSkeleton: React.FC = () => {
  return (
    <div className="flex w-full max-w-[1024px] flex-col items-start gap-4">
      <div className="flex w-full flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
        <Skeleton variant="text" width={150} height={24} />
        <Skeleton variant="rounded" width={140} height={36} />
      </div>
      <div className="flex w-full grow shrink-0 basis-0 flex-col md:flex-row items-start gap-4">
        {/* At Risk Task Card Skeleton */}
        <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 rounded-lg bg-default-background shadow-sm w-full h-full">
          <div className="flex w-full flex-col items-start gap-2 rounded-[8px] bg-error-100 pl-6 pr-3 pt-2 pb-4">
            <div className="flex items-center gap-2">
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width={40} height={32} />
            </div>
            <Skeleton variant="text" width={120} height={20} />
          </div>
          <div className="flex w-full flex-1 flex-col items-start gap-2 px-6 pb-6">
            <div className="flex w-full flex-col items-start gap-1">
              {[1, 2, 3].map((index) => (
                <div key={index} className="flex items-center gap-2">
                  <Skeleton variant="circular" width={8} height={8} />
                  <Skeleton variant="text" width={120} height={16} />
                </div>
              ))}
            </div>
            <div className="flex flex-1 flex-col justify-end gap-2">
              <Skeleton variant="text" width={150} height={16} />
            </div>
          </div>
        </div>

        {/* In Progress Task Card Skeleton */}
        <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 rounded-lg bg-default-background shadow-sm w-full h-full">
          <div className="flex w-full flex-col items-start gap-2 rounded-[8px] bg-warning-100 pl-6 pr-3 pt-2 pb-4">
            <div className="flex items-center gap-2">
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width={40} height={32} />
            </div>
            <Skeleton variant="text" width={120} height={20} />
          </div>
          <div className="flex w-full flex-1 flex-col items-start gap-2 px-6 pb-6">
            <div className="flex w-full flex-col items-start gap-1">
              {[1, 2].map((index) => (
                <div key={index} className="flex items-center gap-2">
                  <Skeleton variant="circular" width={8} height={8} />
                  <Skeleton variant="text" width={120} height={16} />
                </div>
              ))}
            </div>
            <div className="flex flex-1 flex-col justify-end gap-2">
              <Skeleton variant="text" width={150} height={16} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 